module.exports = __webpack_public_path__ + "static/img/sc4.2a9a255.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc4.png
// module id = GfVY
// module chunks = 25